<template>
  <div class="wrapper">
    <section class="portals-screen catg-section-space">
      <div class="container">
        <div class="category-cntr">
          <div class="row">
            <div class="col-md-12">
              <div class="generic-wizard-heading">Portals</div>
              <div class="generic-click-heading">
                Don’t worry you are just a click away.
              </div>
              <div class="portals-boxes">
                <div class="portal-board-box">
                  <a :href="gotoPortal()">
                    <div>
                      <div class="board-box-head">
                        <div class="course-icon">
                          <h4>KIPS LMS</h4>
                          <!-- <img src="/assets/images/os-images/portal-kipslms.png" alt="" /> -->
                        </div>
                        <!-- <h4>KIPS LMS</h4> -->
                      </div>
                    </div>
                  </a>
                </div>
                <div class="portal-board-box">
                  <a href="https://www.oxfordextend.com.pk/">
                    <div>
                      <div class="board-box-head">
                        <div class="course-icon">
                          <h4>DIGITAL RESOURCE</h4>
                          <!-- <img src="/assets/images/os-images/portal-oxford1.png" alt="" /> -->
                        </div>
                        <!-- <h4>Digital Resource</h4> -->
                      </div>
                    </div>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import footer from "../layout/landing/appFooter.vue";
import pageHeader from "../components/pageHeader.vue";

export default {
  components: {
    appFooter: footer,
    pageHeader,
  },
  metaInfo: {
    title: "Portals | KIPS ONLINE SCHOOL",
    // meta: [
    //   {
    //     name: "description",
    //     content:
    //       "Epiloge is about connecting in your field of interest. Our vision is to help people share their knowledge, work, projects, papers and ideas and build their network through what they do rather where they live, study or work.",
    //   },
    //   {
    //     property: "og:title",
    //     content: "Epiloge - Build your network in your field of interest",
    //   },
    // ],
    titleTemplate: "",
    htmlAttrs: {
      lang: "en",
      amp: true,
    },
  },
  computed: {},
  asyncData({ store, route }) {},
  created() {},
  mounted() {
    window.scrollTo(0, 0);
  },
  methods: {
    gotoPortal() {
      return `${process.env.VUE_APP_PORTAL_URL}/dashboard`;
    },
  },
};
</script>
